import { render, staticRenderFns } from "./PaisForm.vue?vue&type=template&id=154636fe"
import script from "./PaisForm.vue?vue&type=script&lang=js"
export * from "./PaisForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports